import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  public encrypt(sk: string, value: string): string {
    const utf8Key = CryptoJS.enc.Utf8.parse(sk);
    const utf8Iv = CryptoJS.enc.Utf8.parse(sk);
    const utf8Val = CryptoJS.enc.Utf8.parse(value);

    const options: any = {
      keySize: 128 / 8,
      iv: utf8Iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    };

    const encrypted: any = CryptoJS.AES.encrypt(utf8Val, utf8Key, options);
    return encrypted.toString();
  }

  public decrypt(sk: string, value: string): string {
    const utf8Key = CryptoJS.enc.Utf8.parse(sk);
    const utf8Iv = CryptoJS.enc.Utf8.parse(sk);

    const options: any = {
      keySize: 128 / 8,
      iv: utf8Iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    };

    const decrypted: any = CryptoJS.AES.decrypt(value, utf8Key, options);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  public _encrypt(sk: string, value: string): string {
    try {
      const utf8Val = CryptoJS.enc.Utf8.parse(value);
      const encrypted: any = CryptoJS.AES.encrypt(utf8Val, sk);
      return encrypted.toString();
    } catch (e) {
      return '';
    }
  }

  public _decrypt(sk: string, value: string): string {
    try {
      const decrypted: any = CryptoJS.AES.decrypt(value, sk);
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      return '';
    }
  }
}
